export default {
  FETCH_supporterS_REQUEST: 'FETCH_supporterS_REQUEST',
  FETCH_supporterS_FAILED: 'FETCH_supporterS_FAILED',
  FETCH_supporterS_SUCCESS: 'FETCH_supporterS_SUCCESS',

  DELETE_supporter_REQUEST: 'DELETE_supporter_REQUEST',
  DELETE_supporter_FAILED: 'DELETE_supporter_FAILED',
  DELETE_supporter_SUCCESS: 'DELETE_supporter_SUCCESS'
};
